export enum ImportExportServiceType {
    ExpressImport,
    ExpressExport,
    SeaImport,
    SeaExport,
    AirImport,
    AirExport,
}